<div class="chat-question-container">
  @if (files()?.length) {
    <div class="files-container">
      @for (file of files(); track $index) {
        <chat-file [file]="file" [viewMode]="'view'"></chat-file>
      }
    </div>
  }
  @if (isQuoteMessage()) {
    <div class="chat-quote-question">
      <div class="quote-question" (click)="isExpanded.set(!isExpanded())">
        <div #quoteText dir="auto" class="quote-question-text" [class.expanded]="isExpanded()" [class.overflowed]="isOverflowed()">
          {{ message().action.quote }}
        </div>
        @if (isOverflowed() && !isExpanded()) {
          <div class="quote-question-show-more">Show more...</div>
        }
      </div>
      <div class="action-question">
        @if (actionMessage().icon) {
          <u-icon [model]="{ type: 'font', value: actionMessage().icon }" [styles]="{ fontSize: '14px' }"></u-icon>
        }
        {{ actionMessage().text }}
      </div>
    </div>
  }
  @if (message()?.content?.length && !isQuoteMessage()) {
    <div class="chat-question">
      <div class="content">
        <div class="query-text" dir="auto" [innerHTML]="message().content | richTextFormatted"></div>
        <ng-container *ngIf="filtersToolTip()">
          <div class="question-filters" [pTooltip]="filtersToolTip()" tooltipPosition="bottom" tooltipStyleClass="u-tooltip">
            <u-icon [model]="{ type: 'font-icon', value: 'icon-sort-down' }"></u-icon>
            <span>Filters applied</span>
          </div></ng-container
        >
      </div>
    </div>
  }
</div>
